import HomePage from "./pages/HomePage/HomePage";
import AboutUs from "./pages/AboutUs/AboutUs";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminDashboard from "./pages/AdminDashboard1/AdminDashboard";
import AdminDashboard2 from "./pages/AdminDashboard2/AdminDashboard2";
import AdminDashboard3 from "./pages/AdminDashboard3/AdminDashboard3";
import UserDashboard from "./pages/UserDashBoard/UserDashBoard";
import Announcement from "./pages/Announcements/Announcement";
import Blogs from './pages/Blogs/Blogs'
import InnerBlog from './pages/Blogs/InnerBlog'
import ContactUs from './pages/ContactUs/ContactUs'
import Events from "./pages/Events/Events";
import LoginPage from './pages/LoginPage/Login.js';
import SignupPage from './pages/SignupPage/SignUp';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { AdminPrivateRoute1 } from './components/PrivateRoutes/PrivateRoute'
import { AdminPrivateRoute2 } from './components/PrivateRoutes/PrivateRoute'
import { AdminPrivateRoute3 } from './components/PrivateRoutes/PrivateRoute'
import { UserPrivateRoute } from './components/PrivateRoutes/PrivateRoute'
import './App.css'
import ChatBot from "./components/ChatBot/ChatBot";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import Newsletter from "./pages/Newsletter/Newsletter";

function App() {
  return (
    <div className="App">
      <ChatBot />
      <Router>
        <Routes>
          <Route exact path="/" element={<HomePage />} />
          <Route exact path="/about-us" element={<AboutUs />} />
          <Route exact path="/newsletter" element={<Newsletter />} />
          <Route exact path="/announcements" element={<Announcement />} />
          <Route exact path="/contact-us" element={<ContactUs />} />
          <Route exact path="/blogs" element={<Blogs />} />
          <Route exact path="/ReadArticles" element={<InnerBlog />} />
          <Route exact path="/events" element={<Events />} />
          <Route element={<AdminPrivateRoute1 />}>
            <Route path="/admin-dashboard-1" element={<AdminDashboard />} />
          </Route>
          <Route exact path="/" element={<AdminPrivateRoute2 />}>
            <Route path="/admin-dashboard-2" element={<AdminDashboard2 />} />
          </Route>
          <Route exact path="/" element={<AdminPrivateRoute3 />}>
            <Route path="/admin-dashboard-3" element={<AdminDashboard3 />} />
          </Route>
          <Route exact path="/" element={<UserPrivateRoute />}>
            <Route path="/user-dashboard" element={<UserDashboard />} />
          </Route>
          <Route exact path="/login" element={<LoginPage />} />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route exact path="/sign-in" element={<SignupPage />} />
          <Route exact path="/forgot/:id" element={<ResetPassword />} />





        </Routes>
        <ToastContainer />
      </Router>
    </div>
  );
}

export default App;
